import { render, staticRenderFns } from "./BaseColumn.vue?vue&type=template&id=bd505d8c"
import script from "./BaseColumn.vue?vue&type=script&lang=js"
export * from "./BaseColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports